import {
    CHANNELS_URL,
    urlFetchChannel,
    urlFetchChannelAvailability,
    urlFetchChannelIV,
    urlFetchChannels,
} from '../../constants/restURL';
import Axios from 'axios';
import {
    CHANNEL_ADD_ERROR,
    CHANNEL_ADD_IN_PROGRESS,
    CHANNEL_ADD_SUCCESS,
    CHANNEL_CHANGE_DIALOG_HIDE,
    CHANNEL_CHANGE_DIALOG_SHOW,
    CHANNEL_DESCRIPTION_SET,
    CHANNEL_ID_SET,
    CHANNEL_INFO_IV_SORT_VALUE_SET,
    CHANNEL_INFO_IV_TAB_SET,
    CHANNEL_NAME_SET,
    CHANNEL_UPDATE_ERROR,
    CHANNEL_UPDATE_IN_PROGRESS,
    CHANNEL_UPDATE_SUCCESS,
    CHANNEL_USER_NAME_SET,
    CHANNEL_USER_NAME_STATUS_SET,
    CHANNEL_USERNAME_SETTINGS_SET,
    CHANNELS_SETTINGS_TAB_SET,
    CREATE_CHANNEL_DIALOG_HIDE,
    CREATE_CHANNEL_DIALOG_SHOW,
    FETCH_CHANNEL_AVAILABILITY_SUCCESS,
    FETCH_CHANNEL_INFO_ERROR,
    FETCH_CHANNEL_INFO_IN_PROGRESS,
    FETCH_CHANNEL_INFO_SUCCESS,
    FETCH_CHANNEL_IV_ERROR,
    FETCH_CHANNEL_IV_IN_PROGRESS,
    FETCH_CHANNEL_IV_SUCCESS,
    FETCH_CHANNELS_AVAILABILITY_ERROR,
    FETCH_CHANNELS_AVAILABILITY_IN_PROGRESS,
    FETCH_CHANNELS_ERROR,
    FETCH_CHANNELS_IN_PROGRESS,
    FETCH_CHANNELS_SUCCESS,
    SAVE_BUTTON_ENABLE_SET,
    SETTINGS_CHANNEL_ADDRESS_SET,
    SETTINGS_CHANNEL_DESCRIPTION_SET,
    SETTINGS_CHANNEL_IMAGE_SET,
    SETTINGS_CHANNEL_NAME_SET,
    SETTINGS_CHANNEL_ALLOW_PUBLISHERS_SET,
} from '../../constants/channels';
import { handleErrorMessage } from '../../utils/errorMessages';

export const setChannelID = (value) => {
    return {
        type: CHANNEL_ID_SET,
        value,
    };
};

export const setChannelInfoIVTab = (value) => {
    return {
        type: CHANNEL_INFO_IV_TAB_SET,
        value,
    };
};

export const setChannelInfoIVSort = (value) => {
    return {
        type: CHANNEL_INFO_IV_SORT_VALUE_SET,
        value,
    };
};

export const setSettingsChannelImage = (value) => {
    return {
        type: SETTINGS_CHANNEL_IMAGE_SET,
        value,
    };
};

export const setSettingsChannelAllowPublishers = (value) => {
    return {
        type: SETTINGS_CHANNEL_ALLOW_PUBLISHERS_SET,
        value,
    };
};

export const setSettingsChannelName = (value) => {
    return {
        type: SETTINGS_CHANNEL_NAME_SET,
        value,
    };
};

export const setSettingsChannelDescription = (value, valid) => {
    return {
        type: SETTINGS_CHANNEL_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setSettingsChannelAddress = (value) => {
    return {
        type: SETTINGS_CHANNEL_ADDRESS_SET,
        value,
    };
};

export const showChannelChangeDialog = () => {
    return {
        type: CHANNEL_CHANGE_DIALOG_SHOW,
    };
};

export const hideChannelChangeDialog = () => {
    return {
        type: CHANNEL_CHANGE_DIALOG_HIDE,
    };
};

export const setChannelSettingsTab = (value) => {
    return {
        type: CHANNELS_SETTINGS_TAB_SET,
        value,
    };
};

export const setChannelName = (value) => {
    return {
        type: CHANNEL_NAME_SET,
        value,
    };
};

export const setChannelUserNameSettings = (value) => {
    return {
        type: CHANNEL_USERNAME_SETTINGS_SET,
        value,
    };
};

export const setChannelDescription = (value) => {
    return {
        type: CHANNEL_DESCRIPTION_SET,
        value,
    };
};

export const setSaveButtonEnable = (value) => {
    return {
        type: SAVE_BUTTON_ENABLE_SET,
        value,
    };
};

// Open Edition mint
const fetchChannelsInProgress = () => {
    return {
        type: FETCH_CHANNELS_IN_PROGRESS,
    };
};

const fetchChannelsSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CHANNELS_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchChannelsError = (message) => {
    return {
        type: FETCH_CHANNELS_ERROR,
        message,
    };
};

export const fetchChannels = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchChannelsInProgress());

    const url = urlFetchChannels(skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelsError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const showCreateChannelDialog = () => {
    return {
        type: CREATE_CHANNEL_DIALOG_SHOW,
    };
};

export const hideCreateChannelDialog = () => {
    return {
        type: CREATE_CHANNEL_DIALOG_HIDE,
    };
};

export const setChannelUserName = (value) => {
    return {
        type: CHANNEL_USER_NAME_SET,
        value,
    };
};

const addChannelInProgress = () => {
    return {
        type: CHANNEL_ADD_IN_PROGRESS,
    };
};

const addChannelSuccess = (value) => {
    return {
        type: CHANNEL_ADD_SUCCESS,
        value,
    };
};

const addChannelError = (message) => {
    return {
        type: CHANNEL_ADD_ERROR,
        message,
    };
};

export const addChannel = (data, cb) => (dispatch) => {
    dispatch(addChannelInProgress());

    Axios.post(CHANNELS_URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            const result = res?.data?.result || res?.data?.channel;
            dispatch(addChannelSuccess(result));
            if (cb) {
                cb(result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addChannelError(message));
            if (cb) {
                cb(null);
            }
        });
};

const updateChannelInProgress = () => {
    return {
        type: CHANNEL_UPDATE_IN_PROGRESS,
    };
};

const updateChannelSuccess = (value) => {
    return {
        type: CHANNEL_UPDATE_SUCCESS,
        value,
    };
};

const updateChannelError = (message) => {
    return {
        type: CHANNEL_UPDATE_ERROR,
        message,
    };
};

export const updateChannel = (id, data, cb) => (dispatch) => {
    dispatch(updateChannelInProgress());

    const url = urlFetchChannel(id);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(updateChannelSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateChannelError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchChannelInfoInProgress = () => {
    return {
        type: FETCH_CHANNEL_INFO_IN_PROGRESS,
    };
};

const fetchChannelInfoSuccess = (value) => {
    return {
        type: FETCH_CHANNEL_INFO_SUCCESS,
        value,
    };
};

const fetchChannelInfoError = (message) => {
    return {
        type: FETCH_CHANNEL_INFO_ERROR,
        message,
    };
};

export const fetchChannelInfo = (id, cb) => (dispatch) => {
    dispatch(fetchChannelInfoInProgress());

    const url = urlFetchChannel(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelInfoSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelInfoError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchChannelIVInProgress = () => {
    return {
        type: FETCH_CHANNEL_IV_IN_PROGRESS,
    };
};

const fetchChannelIVSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CHANNEL_IV_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchChannelIVError = (message) => {
    return {
        type: FETCH_CHANNEL_IV_ERROR,
        message,
    };
};

export const fetchChannelIV = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchChannelIVInProgress());

    const url = urlFetchChannelIV(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelIVSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelIVError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const setChannelUserNameStatus = (value) => {
    return {
        type: CHANNEL_USER_NAME_STATUS_SET,
        value,
    };
};

const fetchChannelAvailabilityInProgress = () => {
    return {
        type: FETCH_CHANNELS_AVAILABILITY_IN_PROGRESS,
    };
};

const fetchChannelAvailabilitySuccess = (value) => {
    return {
        type: FETCH_CHANNEL_AVAILABILITY_SUCCESS,
        value,
    };
};

const fetchChannelAvailabilityError = (message) => {
    return {
        type: FETCH_CHANNELS_AVAILABILITY_ERROR,
        message,
    };
};

export const fetchChannelAvailability = (username, cb) => (dispatch) => {
    dispatch(fetchChannelAvailabilityInProgress());

    const data = {
        username: username,
    };
    const url = urlFetchChannelAvailability();
    Axios.post(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelAvailabilitySuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelAvailabilityError(message));
            if (cb) {
                cb(null, message);
            }
        });
};
